define('drops/richTextTemplateEditor/richTextTemplateEditor',['jquery', 'lq', 'lq/drop', 'lq/style', 'lq/dispatcher', 'lq/richText', 'underscore'], function ($, lq, Drop, Style, dispatcher, richText, _) {
    'use strict';

    var defaults = {
        data: {
            entity: "RichTextTemplate",
            nameColumn: "Name",
            categoryColumn: "Category",
            modelColumn: "Model",
            size: {
                x: 450,
                y: 330
            }
        }
    };

    var TemplateSelector = function (richTextTemplateEditor) {
        var self = this;

        self.richTextTemplateEditor = richTextTemplateEditor;
        self.data = richTextTemplateEditor.data;
        self.templates = [];
        
        self.$element = $('<div />');

        $('<span />')
            .text('Templates: ')
            .appendTo(this.$element);

        self.$templates = $('<select />')
            .on('change', function () {
                var buttonDisabled = self.$templates.prop("selectedIndex") === 0;
                self.$load.prop('disabled', buttonDisabled);
                self.$delete.prop('disabled', buttonDisabled);
            })
            .append($('<option />', { value: null, text: 'Choose a template ...' }))
            .appendTo(this.$element);

        self.$load = $('<button />')
            .text('Load')
            .prop('disabled', true)
            .on('click', function() {
                if (!confirm('Are you sure you want to load the selected template?\nYour current unsaved changes will be lost!')) {
                    return;
                }

                dispatcher.dispatch(
                    'Entity/LoadRichTextTemplate',
                    {
                        actionId: self.piping.actionId,
                        morphId: self.data.id,
                        id: self.$templates.val()
                    },
                    function (data) {
                        richTextTemplateEditor.openTemplate(data.Values);
                    });
            })
            .appendTo(self.$element);

        self.$delete = $('<button />')
            .text('Delete')
            .prop('disabled', true)
            .on('click', function () {
                if (!confirm('Are you sure you want to delete this template?')) {
                    return;
                }
                
                dispatcher.dispatch(
                    'Entity/DeleteRichTextTemplate',
                    {
                        actionId: self.piping.actionId,
                    	morphId: self.data.id,
                        id: self.$templates.val()
                    },
			        function () {
			            self.loadTemplates();
			        });
            })
            .appendTo(self.$element);

        self.loadTemplates();
    };

    TemplateSelector.prototype.loadTemplates = function(activeTemplateSelector) {
        var self = this;

        this.piping.queryDispatcher.dispatch(
            self.data.dataSource,
			function (data) {
			    self.templates = data.Results; // TODO: map fields here so different attribute names can be used

			    self.$templates
			        .empty()
			        .append($('<option />', { value: null, text: 'Choose a template ...' }));

			    $.each(self.templates, function (key, template) {
			        self.$templates
			            .append($('<option />', {
			                value: template.Id,
			                text: template[self.data.nameColumn]
			            }));
			    });

			    var disableButtons = !self.tryToSelectItem(activeTemplateSelector);
			    self.$load.prop('disabled', disableButtons);
			    self.$delete.prop('disabled', disableButtons);
			});
    };

    TemplateSelector.prototype.tryToSelectItem = function (selector) {
        if (selector) {
            var foundTemplate = _.find(this.templates, selector);
            
            if (foundTemplate) {
                this.$templates.val(foundTemplate.Id);
                return true;
            }
        }

        return false;
    };
    
    TemplateSelector.prototype.findTemplateWithName = function (name) {
    	var self = this;
        return _.find(this.templates, function (t) {
        	return t[self.data.nameColumn] === name;
        });
    };

    TemplateSelector.prototype.clearSelection = function () {
        this.$templates.val(null);
    };

    var TemplateSaver = function (richTextTemplateEditor) {
        var self = this;

        self.richTextTemplateEditor = richTextTemplateEditor;
        self.data = richTextTemplateEditor.data;
        self.$element = $('<div />');

        $('<span />')
            .text('Save as template: ')
            .appendTo(this.$element);

        self.$name = $('<input />')
            .on('keyup', function () {
                self.updateButton();
            })
            .appendTo(this.$element);

        self.$button = $('<button />')
            .text(' Save ')
            .prop('disabled', true)
            .on('click', function() {
                self.save();
            })
            .appendTo(this.$element);
    };

    TemplateSaver.prototype.save = function () {
        var self = this;
        var name = self.$name.val();
        var existingTemplate = self.richTextTemplateEditor.findTemplateWithName(name);

        if (existingTemplate) {
            if (!confirm('Are you sure you want to overwrite the existing template "' + name + '" ?')) {
                return;
            }
        }

        var model = self.richTextTemplateEditor.richTextEditor.toModel();

        var data = {
            actionId: self.piping.actionId,
        	morphId: self.data.id,
			id: existingTemplate ? existingTemplate.Id : null,
			"Values[0].Key": self.data.categoryColumn,
			"Values[0].Value": self.richTextTemplateEditor.getCategory(),
			"Values[1].Key": self.data.nameColumn,
			"Values[1].Value": name,
			"Values[2].Key": self.data.modelColumn,
			"Values[2].Value": JSON.stringify(model)
        };

        dispatcher.dispatch(
           'Entity/SaveRichTextTemplate',
           data,
           function () {
               self.richTextTemplateEditor.templateSelector.loadTemplates(function(t) {
                   return t[self.data.nameColumn] === name;
               });
           });
    };

    TemplateSaver.prototype.setCurrentTemplate = function(name) {
        this.$name.val(name);
        this.updateButton();
    };

    TemplateSaver.prototype.updateButton = function () {
        if (this.$name.val()) {
            this.$button.prop('disabled', false);
        } else {
            this.$button.prop('disabled', true);
        }
    };

    TemplateSaver.prototype.clearName = function () {
        this.$name.val('');
        this.updateButton();
    };

    function RichTextTemplateEditor(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.templateSelector = new TemplateSelector(self);
        self.templateSaver = new TemplateSaver(self);

        self.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        Style.renderStyles(self);

        var $editor = $('<div />')
            .appendTo(self.$element);

        $('<div />')
            .css({
                position: 'absolute',
                top: '10px',
                right: '10px'
            })
            .append(self.templateSelector.$element)
            .appendTo($editor);

        var $richTextEditor = $('<div />')
            .css({
                position: 'absolute',
                top: '40px',
                bottom: '0',
                left: '0',
                right: '0'
            })
            .appendTo($editor);

        self.richTextEditor = new richText.RichTextEditor({
            parentElement: $richTextEditor,
            sections: this.data.sections,
            placeholder: this.data.placeholder,
            addDefaultEmptyRow: false,
            editable: true
        });
        
        $('<div />')
            .css({
                position: 'absolute',
                bottom: '10px',
                right: '10px'
            })
            .append(self.templateSaver.$element)
            .appendTo($editor);
    }

    Drop.extend(RichTextTemplateEditor, Drop);

    RichTextTemplateEditor.typeName = 'RichTextTemplateEditor';

    RichTextTemplateEditor.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    RichTextTemplateEditor.prototype.findTemplateWithName = function (name) {
        return this.templateSelector.findTemplateWithName(name);
    };

    RichTextTemplateEditor.prototype.openTemplate = function (template) {
    	this.richTextEditor.fromModel(JSON.parse(template[this.data.modelColumn]));
        this.templateSaver.setCurrentTemplate(template[this.data.nameColumn]);
    };

    RichTextTemplateEditor.prototype.getCategory = function () {
        if (!this.data.categoryIsParameter) {
            return this.data.category;
        }

        return this.piping.parameters.getValue(this.data.category);
    };

    RichTextTemplateEditor.prototype.getValue = function () {
        if (!this.richTextEditor)
            return null;

        return this.richTextEditor.toString();
    };

    RichTextTemplateEditor.prototype.setValue = function (update) {
        this.templateSelector.clearSelection();
        this.templateSaver.clearName();
        this.richTextEditor.fromString(update.value);
    };

    RichTextTemplateEditor.prototype.clearValue = function (update) { };
    
    return RichTextTemplateEditor;
});
